import React from 'react';
import './VideoModal.css';

const VideoModal = ({ isOpen, onClose, videoSrc, title = "Instruction Video" }) => {
  if (!isOpen) return null;

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="video-modal-header">
          <h3>🎥 {title}</h3>
          <button className="video-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="video-container">
          <video 
            controls 
            autoPlay 
            className="instruction-video"
            onEnded={onClose}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
        <div className="video-modal-footer">
          <p className="video-instructions">
            📋 Watch the video to learn how to use your PIN code to access the locker
          </p>
          <button className="video-close-btn-secondary" onClick={onClose}>
            ✅ Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
